import React from "react";
import { ActionTypes } from "../../action-type";

export const RoomIdProvider = (roomId) => async(dispatch)=>{
    dispatch({
        type:ActionTypes.ROOMID,
        payload:{roomId}
    })
};